<template>
  <MenuRef :iShow="showColor" :openKeys="SubMenu">
    <div class="app-container">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">年份:</div>
            <a-select
              show-search
              :allowClear="true"
              :filterOption="filterOption"
              v-model="year"
              @select="yearSelect"
              placeholder="请输入对应年份"
              style="width: 434px; height: 40px; flex: 1 1 0%"
            >
              <a-select-option
                v-for="yearOption in yearOptions"
                :key="yearOption.value"
                :value="yearOption.value"
              >
                {{ yearOption.label }}
              </a-select-option>
            </a-select>
          </div>

          <div
            class="search-item"
            style="display: flex; justify-content: flex-end"
          >
            <a-button
              class="search-btn"
              :style="{ marginLeft: '24px' }"
              @click="searchData"
            >
              查询
            </a-button>
          </div>
        </div>
      </div>
      <a-spin :spinning="loading" tip="表格数据保存中，请等待...">
        <div class="table-style">
          <div class="royalty-view">
            <div class="tol-item">
              <div>
                <el-button
                  type="success"
                  v-if="permissions.companyCostSheet.canEdit"
                  @click="insertRow()"
                  >添加一行</el-button
                >
                <a-button
                  v-else
                  type="primary"
                  style="width: 98px !important"
                  disabled
                >
                  添加一行
                </a-button>
              </div>
              <div>
                <a-button
                  v-if="permissions.companyCostSheet.canExport"
                  :style="{ marginLeft: '16px' }"
                  class="search-normal"
                  @click=""
                >
                  导出
                </a-button>
                <a-button
                  v-else
                  :style="{ marginLeft: '16px' }"
                  type="primary"
                  disabled
                >
                  导出
                </a-button>
              </div>
            </div>
            <div class="tol-item" v-show="isEdit">
              <div :style="{ marginLeft: '16px' }">
                <el-button type="success" @click="saveData()" plain
                  >保存</el-button
                >
              </div>
            </div>
          </div>
          <el-table
            :data="tableData"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              v-if="permissions.companyCostSheet.canEdit"
              type="selection"
              align="center"
              width="40"
            >
            </el-table-column>
            <el-table-column prop="id" align="center" label="序号">
              <template slot-scope="scope">
                <div v-if="scope.row.id == 6666" class="txt">请添加</div>
                <div v-else class="txt">{{ scope.row.id }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              width="140"
              label="类型/月份"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit"
                  class="item"
                  v-model="scope.row.type"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">{{ scope.row.type }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="t1" align="center" label="1月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t1"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t1 ? `￥${scope.row.t1}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t2" align="center" label="2月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t2"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t2 ? `￥${scope.row.t2}` : "" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="t3" align="center" label="3月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t3"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t3 ? `￥${scope.row.t3}` : "" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="t4" align="center" label="4月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t4"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t4 ? `￥${scope.row.t4}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t5" align="center" label="5月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t5"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t5 ? `￥${scope.row.t5}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t6" align="center" label="6月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t6"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t6 ? `￥${scope.row.t6}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t7" align="center" label="7月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t7"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t7 ? `￥${scope.row.t7}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t8" align="center" label="8月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t8"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t8 ? `￥${scope.row.t8}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t9" align="center" label="9月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t9"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t9 ? `￥${scope.row.t9}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t10" align="center" label="10月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t10"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t10 ? `￥${scope.row.t10}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t11" align="center" label="11月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t11"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t11 ? `￥${scope.row.t11}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="t12" align="center" label="12月">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit == 1"
                  class="item"
                  v-model="scope.row.t12"
                  placeholder="请输入"
                ></el-input>
                <div v-else class="txt">
                  {{ scope.row.t12 ? `￥${scope.row.t12}` : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="total"
              width="140"
              align="center"
              label="合计"
            >
              <template slot-scope="scope">
                <div
                  class="txt"
                  style="color: #ffb319 !important; font-weight: bold"
                >
                  ￥{{ scope.row.total }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </a-spin>
    </div>
  </MenuRef>
</template>

<script>
import MenuRef from "./common/MenuRef";
import { getFeeList, addFeeData, addFeeType } from "@/api";
import { create, all } from "mathjs";
const math = create(all, { number: "BigNumber", precision: 20 });
const { format, bignumber, add, subtract, multiply, divide } = math;
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  name: "Batch",
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      showColor: ["7"],
      SubMenu: ["sub-caidan"],
      // 表格数据
      tableData: [],
      year: new Date().getFullYear(),
      yearOptions: [],
      test: {},
      selectedRows: [],
      isEdit: false,
      showRegualr: true,
      data2: [],
      feeTypeList: [],
      loading: false,
    };
  },
  created() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.generateYearOptions();
    this.fectData();
    this.handleCellLeave;
  },
  methods: {
    yearSelect(year) {
      this.year = year;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = 2020;
      for (let year = currentYear; year >= startYear; year--) {
        this.yearOptions.push({ value: year, label: `${year}年` });
      }
    },
    searchData() {
      this.fectData();
    },
    async saveData() {
      this.data2 = [];
      this.feeTypeList = [];
      // 筛选出 newType 为 true 的对象并构造 aaa 数组
      let newTypeItems = this.tableData.filter((item) => item.newType);
      let dataList = newTypeItems.map((item) => ({
        name: item.type,
        sortNumber: item.id,
        year: this.year,
      }));

      //数组不为空，调用 addFeeType 方法
      if (dataList.length > 0) {
        addFeeType(dataList).then(async (res) => {
          if (res.statusCode == 200) {
            let data = [];
            // 处理响应
            res.data.forEach(async (item) => {
              data.push({
                name: item.name,
                id: item.id,
                sortNumber: item.sortNumber,
              });
            });
            this.feeTypeList = data;
            await this.getData2(data);
          } else {
            this.$Message.error("添加类型出错!");
          }
        });
      } else {
        this.getData2();
      }
    },
    async getData2(feeTypeList) {
      this.showRegualr = true;
      let ids = null;
      let foundItem = [];
      this.tableData.forEach(async (item) => {
        if (feeTypeList && feeTypeList.length > 0) {
          // 使用 find 方法根据 sortNumber 找到对应的对象
          foundItem = feeTypeList.find((items) => items.sortNumber == item.id);
          feeTypeList.forEach((items) => {
            if (items.sortNumber == item.sortNumber) {
              foundItem = items;
            }
          });

          // 获取对应的 id，如果找到的话
          ids = foundItem ? foundItem.id : null;
        }

        for (let i = 1; i <= 12; i++) {
          let priceKey = `t${i}`;
          let idKey = `${priceKey}Id`;
          if (item[priceKey]) {
            if (this.isNumber(item[priceKey])) {
              let data2Item = {
                id: item[idKey] || undefined,
                month: i,
                price: parseFloat(item[priceKey]),
                year: parseInt(item.year),
                feeTypeId: ids || item.feeTypeId || "",
              };

              if (!data2Item.id) {
                delete data2Item.id;
              }

              this.data2.push(data2Item);
            } else {
              this.showRegualr = false;
            }
          }
        }
      });

      if (!this.showRegualr) {
        this.$Message.error("所填内容存在非数字类型!");
        return;
      }
      this.loading = true;
      await addFeeData(this.data2).then((res) => {
        if (res.statusCode == 200) {
          this.isEdit = false;
          this.$Message.success("保存成功！");
          this.fectData();
        } else {
          this.isEdit = true;
          this.$Message.error("保存失败，数据有问题！");
        }
        this.loading = false;
      });
    },
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    //保证精度
    accCalculate(type, ...rest) {
      // add加 subtract减 multiply乘 devide除
      let opear = add;
      switch (type) {
        case "+": // 加
          opear = add;
          break;
        case "-": // 减
          opear = subtract;
          break;
        case "*": // 乘
          opear = multiply;
          break;
        case "/": // 除
          opear = divide;
          break;
      }
      return rest.reduce(
        (total, item) => +format(opear(bignumber(total), bignumber(item)))
      );
    },
    async fectData() {
      await getFeeList(this.year).then((res) => {
        if (res.data.list.length > 0) {
          let list = res.data.list;
          let list2 = list.map((item) => ({
            id: item.sortNumber,
            type: item.name,
            feeTypeId: item.id,
            year: this.year,
            t1: "",
            t1Id: "",
            t2: "",
            t2Id: "",
            t3: "",
            t3Id: "",
            t4: "",
            t4Id: "",
            t5: "",
            t5Id: "",
            t6: "",
            t6Id: "",
            t7: "",
            t7Id: "",
            t8: "",
            t8Id: "",
            t9: "",
            t9Id: "",
            t10: "",
            t10Id: "",
            t11: "",
            t11Id: "",
            t12: "",
            t12Id: "",
            total: 0,
          }));
          // 遍历 list 中的每一个 fee
          list.forEach((item, index) => {
            let feeFound = {};
            item.fee.forEach((feeItem) => {
              // 计算出 t 对应的字段名
              let monthField = `t${feeItem.month}`;
              let monthFieldId = `${monthField}Id`;

              // 查找 list2 中的对应项
              let list2Item = list2[index];
              if (list2Item[monthField] !== undefined) {
                // 更新对应月份的值
                list2Item[monthField] = parseFloat(feeItem.price);
                list2Item[monthFieldId] = feeItem.id;
                feeFound[feeItem.month] = true;
              }
            });

            // 检查是否所有月份都有数据，如果没有则设置为 '--'
            let list2Item = list2[index];
            for (let i = 1; i <= 12; i++) {
              let monthField = `t${i}`;
              if (!feeFound[i] && list2Item[monthField] === "") {
                list2Item[monthField] = "";
                list2Item[`${monthField}Id`] = "";
              }
            }
          });

          this.getTotalSum(list2);
        }
      });
    },
    getTotalSum(list2) {
      // 计算 total 字段的总和
      list2.forEach((item) => {
        item.total = 0;
        for (let i = 1; i <= 12; i++) {
          let monthField = `t${i}`;
          if (item[monthField]) {
            item.total += parseFloat(item[monthField]);
          }
        }
      });

      this.tableData = list2;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(selection) {
      // 清空上次选中的行的编辑状态
      this.selectedRows.forEach((row) => {
        this.isEdit = false;
        row.isEdit = 0;
      });

      // 更新选中的行数组
      this.selectedRows = selection;

      // 设置选中的行的编辑状态
      this.selectedRows.forEach((row) => {
        this.isEdit = true;
        row.isEdit = 1;
      });
    },
    insertRow() {
      let list = {
        id: this.tableData[this.tableData.length - 1].id + 1,
        type: "",
        newType: true,
        year: this.year,
        t1: "",
        t1Id: "",
        t2: "",
        t2Id: "",
        t3: "",
        t3Id: "",
        t4: "",
        t4Id: "",
        t5: "",
        t5Id: "",
        t6: "",
        t6Id: "",
        t7: "",
        t7Id: "",
        t8: "",
        t8Id: "",
        t9: "",
        t9Id: "",
        t10: "",
        t10Id: "",
        t11: "",
        t11Id: "",
        t12: "",
        t12Id: "",
        total: "",
      };
      this.tableData.push(list);
      // 更新选中的行数组
      this.selectedRows = [list];

      // 设置选中的行的编辑状态
      this.selectedRows.forEach((row) => {
        this.isEdit = true;
        row.isEdit = 1;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      // 初始化 sums 数组
      for (let i = 0; i < columns.length; i++) {
        sums[i] = 0;
      }

      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = data[data.length - 1].id + 1;
        } else if (index === 2) {
          sums[index] = "总计";
        } else if (
          index === 3 ||
          index === 4 ||
          index === 5 ||
          index === 6 ||
          index === 7 ||
          index === 8 ||
          index === 9 ||
          index === 10 ||
          index === 11 ||
          index === 12 ||
          index === 13 ||
          index === 14
        ) {
          data.forEach((item, rowIndex) => {
            // 跳过前三行
            const value = Number(item[column.property]);
            if (!isNaN(value)) {
              sums[index] = this.accCalculate("", sums[index], value);
            }
          });
        } else {
          if (index == 0) {
            sums[index] = "";
          }
        }
      });

      // 计算每一行的总和，并添加到 data 的最后一列
      data.forEach((item, rowIndex) => {
        // 跳过前三行
        let rowSum = 0;
        columns.forEach((column, colIndex) => {
          if (colIndex > 0 && colIndex < columns.length - 1) {
            // 排除第一列和最后一列
            const value = Number(item[column.property]);
            if (!isNaN(value)) {
              if (colIndex > 2) {
                rowSum = this.accCalculate("", value, rowSum);
              }
            }
          }
        });
        item.total = rowSum;
      });

      // 返回 sums 数组，最后一列显示所有行的总和
      sums[columns.length - 1] = data.reduce((total, item, rowIndex) => {
        // 跳过前三行
        if (rowIndex == data.length - 1) {
          return "￥" + this.accCalculate("+", total, item.total);
        } else {
          return this.accCalculate("+", total, item.total);
        }
      }, 0);

      return sums;
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  width: 100px;
  /* 调整elementUI中样式 如果不需要调整请忽略 */
  .el-input__inner {
    height: 24px !important;
  }
}
.txt {
  line-height: 24px;
  padding: 0 9px;
  box-sizing: border-box;
}
.search-cond {
  width: 100%;
  height: 88px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  padding: 24px;

  .search-input {
    width: 336px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .search-item {
      width: 100%;
      display: flex;
      align-items: center;

      .tol-title {
        display: flex;
        justify-content: flex-end;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #313332;
        line-height: 22px;
        font-style: normal;
        margin-right: 10px;
      }
    }
  }

  .search-button {
    margin-top: 8px;
    width: 100%;
    display: flex;
    align-items: center;

    .btn-cond {
      width: calc(100% / 3);
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

.table-style {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  .title {
    display: block;
    border-bottom: solid 1px #384057;
    padding-bottom: 10px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-M;
    line-height: 28px;
    text-align: left;
  }
  .royalty-view {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    width: 100%;
    height: 42px;
    .tol-item {
      display: flex;
      align-items: center;
      .tol-add {
        margin-left: 20px;
      }
      .tol-title {
        margin-right: 6px;
        overflow-wrap: break-word;
        color: rgba(207, 214, 230, 1);
        font-size: 16px;
        font-family: Roboto-Medium;
      }
      .Select-style {
        width: 336px;
        height: 40px;
      }
    }
  }

  /deep/.el-table .cell {
    text-overflow: unset !important;
    font-family: PingFangSC, PingFang SC;
    font-size: 16px;
    color: #313332;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }

  /deep/.el-table th.el-table__cell {
    background: rgba(255, 179, 25, 0.2) !important;
  }

  /deep/.el-table tr {
    background: rgba(255, 179, 25, 0.03) !important;
  }

  /deep/.el-table__footer-wrapper tbody td.el-table__cell {
    background-color: rgba(255, 179, 25, 0.6) !important;
  }

  /deep/.el-table__footer-wrapper {
    font-weight: 600;
  }
}

.search-normal {
  background: transparent;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #969998;
  border-color: #e3e6e4;
  width: 80px;
  height: 40px;
}

.search-normal:hover,
.search-normal:active,
.search-normal:focus {
  background: transparent;
  border-radius: 4px;
  color: #14cc76;
  border-color: #14cc76;
}

.search-btn {
  background: #14cc76;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  border-color: #14cc76;
  width: 80px;
  height: 40px;
}

.search-btn:hover,
.search-btn:active,
.search-btn:focus {
  background: #14cc76;
  border-radius: 4px;
  color: #ffffff;
  border-color: #14cc76;
}

/deep/.ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/.ant-select-selection--multiple .ant-select-selection__rendered {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/.ant-select-search__field__mirror {
  opacity: 1;
}
</style>
